/**
 * @author      luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright   Copyright (c) 2024, Zumper
 */

import { event, getTraktorEntityId } from '@zcode-ui/web-zumper-integrations'
import { EVENT_NAMES, PROP_NAMES, track } from '@zcode/mixpanel'
import type { FiltersState, Listable, Property } from '@zcode/state-type'
import type { Dispatch } from 'redux'

interface Props {
  entity: Listable | Property
  displaying: boolean
  filters: FiltersState
  mmListingIds: number[] | undefined
  shouldLimitLeads: boolean | undefined
  showPreLeadSignInModal: boolean | undefined
}

export const trackPrepareMultiMessageModal =
  ({
    entity,
    displaying,
    filters,
    mmListingIds,
    shouldLimitLeads,
    showPreLeadSignInModal,
  }: Props) =>
  (dispatch: Dispatch) => {
    track({
      event: EVENT_NAMES.PREPARE_MULTI_MESSAGE_MODAL,
      payload: {
        [PROP_NAMES.MM_LISTING_IDS]: mmListingIds,
        [PROP_NAMES.RATE_LIMITED]: !!shouldLimitLeads,
        [PROP_NAMES.IS_RENTPATH]: !!entity?.isRentpath,
        [PROP_NAMES.IS_MM_PREVENT]: !!entity?.isMmPrevent,
        [PROP_NAMES.DISPLAYING]: displaying,
        [PROP_NAMES.SHOW_PRE_LEAD_SIGN_IN]: !!showPreLeadSignInModal,
      },
    })

    dispatch(
      event({
        name: 'PREPARE_MULTI_MESSAGE_MODAL',
        props: {
          propertyId: getTraktorEntityId(entity),
          filters,
          mmListingIds: mmListingIds,
          rateLimited: !!shouldLimitLeads,
          isRentpath: !!entity?.isRentpath,
          isMmPrevent: !!entity?.isMmPrevent,
          displaying,
          showPreLeadSignInModal,
        },
      })
    )
  }
